define('OutSystems/ClientRuntime/modules/Native/Prebundle',["require", "exports", "tslib", "../../NativeHelper", "./IOutSystemsNativeHost"], function (require, exports, tslib_1, NativeHelper, IOutSystemsNativeHost_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getManifest = exports.isPrebundlePluginAvailable = void 0;
    function getPrebundlePlugin() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, NativeHelper.ensureNativeReady()];
                    case 1:
                        _a.sent();
                        if (IOutSystemsNativeHost_1.isIOutSystemsNativeHost(window)) {
                            return [2, window.OutSystemsNative.Prebundle];
                        }
                        else {
                            return [2, null];
                        }
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        return [2, null];
                    case 3: return [2];
                }
            });
        });
    }
    function isPrebundlePluginAvailable() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var prebundlePlugin;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, getPrebundlePlugin()];
                    case 1:
                        prebundlePlugin = _a.sent();
                        return [2, !!prebundlePlugin];
                }
            });
        });
    }
    exports.isPrebundlePluginAvailable = isPrebundlePluginAvailable;
    function getManifest() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var plugin;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, getPrebundlePlugin()];
                    case 1:
                        plugin = _a.sent();
                        if (!plugin) {
                            return [2, null];
                        }
                        return [2, new Promise(function (resolve, reject) {
                                plugin.getManifest(resolve, reject);
                            })];
                }
            });
        });
    }
    exports.getManifest = getManifest;
});
//# sourceMappingURL=Prebundle.js.map;
